import { create, v, w } from '@dojo/framework/core/vdom';
// import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { lccstate, createNlsMiddleware, tapaneChangeProcess, recommended, childmap } from '@holmescorp/lcc-state';

import { OrderProperties } from '../interfaces';

export interface RecommendedOrderProperties extends OrderProperties {}

import css from '../css/content-order.m.css';
import { difference } from '@holmescorp/collections';

const nls = createNlsMiddleware('ditabook');
const factory = create({ theme, nls, lccstate, recommended }).properties<RecommendedOrderProperties>();

export const RecommendedOrder = factory(({ properties, middleware: { theme, lccstate, recommended } }) => {
	const themeCss = theme.classes(css);
	const { hideCompleted } = properties();

	const { get, path, run } = lccstate;
	const tracking = get(path('tracking'));

	let keySet;
	if (tracking) {
		const expandKeys = new Set<string>(get(path('accordionSelected')));
		const localKeys = new Set<string>(childmap.get(tracking.topichead));
		keySet = [...difference(expandKeys, localKeys), ...[tracking.topicset]];
	}
	const topic = recommended.topicsets(hideCompleted);
	const firstIncomplete = recommended.firstIncomplete();
	run(tapaneChangeProcess)({ accordionSelected: keySet ? keySet : [firstIncomplete] });

	// if (firstIncomplete) {
	// 	lccstate.run(tapaneChangeProcess)({ accordionSelected: firstIncomplete });
	// }

	return v('div', { key: 'recommended-order', xqa: `view recommended-order`, classes: [themeCss.root] }, [
		w('TopicAccordion', { topic })
	]);
});
